import React from 'react';
import bem from 'utils/bem';
import { Link } from 'react-router-dom';
import Text from 'components/Text';
import Model from '../../../model';
import './index.sass';
import Icon from 'components/Icon';

const { block } = bem('kz-not-enough-balance');
const KZNotEnoughBalance = ({price}) => {
    const { isAuthenticated, user } = Model.user;
    const { balance } = user;
    if (window.isRuDomain || !isAuthenticated || +balance >= +price) {
        return null;
    }

    return (
        <div className={block()}>
            <Icon name={'warning'} />
            <Text>
                К сожалению, на вашем балансе недостаточно баллов. Пожалуйста, <Link to={'/foreign-payments'}>пополните баланс</Link>
            </Text>
        </div>
    )
}

export default KZNotEnoughBalance;
